import axios from 'axios'

const state = {
  news: [],
}

const mutations = {
  setNewsList (state, payload) { state.news = payload },
}

const actions = {
  fetchNewsList ({ commit, rootGetters }, meta) {
    const params = `?limit=${meta.limit}&offset=${meta.offset}&page=${meta.page}`

    return axios
      .get(`${rootGetters['api/newsList']}${params}`).then(res => {
        commit('setNewsList', res.data.items)
        return res
      })
      .catch(err => err)
  },
  fetchSingleNews ({ rootGetters }, id) {
    return axios
      .get(rootGetters['api/newsSingle'](id)).then(res => {
        return res
      }).catch(err => err)
  },
  createNews ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/newsCreate'], data).then(res => {
        return res
      })
      .catch(err => err)
  },
  editNews ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/newsEdit'](id), data).then(res => {
        return res
      })
      .catch(err => err)
  },
  removeNews ({ rootGetters }, id) {
    return axios
      .delete(rootGetters['api/newsDelete'](id)).then(res => {
        return res
      })
      .catch(err => err)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
